import React from "react";
import { useState } from 'react';
import { fetchWithAuth } from "../auth"

const AddRoom = ({ isOpen, onClose, gw }) => {

    async function addRoom() {
        await fetchWithAuth('/room', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ type: typeState, room: roomState, serial: gw })
        })
            .then(data => {
                setTypeState('')
                setRoomState('')
                onClose()
            })
    }

    const [typeState, setTypeState] = useState('')
    const room_types = ["Cucina", "Stanza da letto", "Bagno", "Postazione lavoro"];
    const handleTypeChange = (event) => { setTypeState(room_types.indexOf(event.target.value)) }
    const [roomState, setRoomState] = useState('')
    const handleRoomChange = (event) => { setRoomState(event.target.value) }

    if (!isOpen) return null;

    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                background: "rgba(0, 0, 0, 0.5)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <div
                style={{
                    background: "white",
                    height: 300,
                    width: 480,
                    margin: "auto",
                    padding: "2%",
                    border: "2px solid #000",
                    borderRadius: "10px",
                    boxShadow: "2px solid black",
                }}
            >
                {/* {children} */}
                <table>
                    <tbody>
                        <tr>
                            <th className="title">type</th>
                            <th className="title">stanza</th>
                        </tr>
                        <tr>
                            <td>
                                <input type="text" name="roomtype" list="roomlist" value={room_types[typeState]} onChange={handleTypeChange} />
                                <datalist id="roomlist">
                                    <option value="Cucina">Cucina</option>
                                    <option value="Stanza da letto">Stanza da letto</option>
                                    <option value="Bagno">Bagno</option>
                                    <option value="Postazione lavoro">Postazione lavoro</option>
                                </datalist>
                            </td>
                            <td> <input type="text" value={roomState} onChange={handleRoomChange} /> </td>
                        </tr>
                    </tbody>
                </table>
                <button type="button" onClick={addRoom}>
                    Aggiungi
                </button>
                <button type="button" onClick={onClose}>
                    Chiudi
                </button>
            </div>
        </div>
    );
};

export default AddRoom;
